<template>

  <div class="sign-form">
    <el-form :model="formData" :rules="rules" ref="formData" class="reset-from">
      <el-form-item prop="username" label="User Name">
        <template slot="label">
          <I18Lang id="user50" defaultText="用户名" />
        </template>
        <el-input @blur="usernameBlur" v-model="formData.username"
        :placeholder="$t('user4')"></el-input>
        <div v-if="formData.account_id" class="account-id">
          <I18Lang id="user5" defaultText="用户ID" />：{{ formData.account_id }}
        </div>
      </el-form-item>

      <el-form-item prop="password" label="Password">
        <template slot="label">
          <I18Lang id="user55" defaultText="密码" />
        </template>
        <el-input type="password" v-model="formData.password" :placeholder="$t('user6')" show-password></el-input>
      </el-form-item>

      <el-form-item prop="rePassword" label="Password Confirmation">
        <template slot="label">
          <I18Lang id="user7" defaultText="确认密码" />
        </template>
        <el-input type="password" v-model="formData.rePassword" show-password
          :placeholder="$t('user99')"></el-input>
      </el-form-item>

      <el-form-item label="Email">
        <template slot="label">
          <I18Lang id="user54" defaultText="邮箱" />
        </template>
        <el-input v-model="formData.email" :placeholder="$t('user8')"></el-input>
      </el-form-item>

      <!-- <el-form-item class="reset-input-code" prop="code" label="Email Verification Code">
        <el-input name="code" class="get-code" autocomplete="off" auto-complete="off" v-model="formData.code"
          placeholder="Please enter the email verification code">
          <template slot="append">
            <SendCode class="btn-send-code" v-model="isSendCode" @click.native="sendEmailCode"
              storage-key="regEmailCode" :initStr="$t('user94')" :class="{ 'btn-loading': sendLoading }" />
          </template>
        </el-input>
      </el-form-item> -->

      <el-form-item label="Phone Number">
        <template slot="label">
          <I18Lang id="user56" defaultText="手机号码" />
        </template>
        <el-input v-model="formData.phone_number" :placeholder="$t('user9')"></el-input>
      </el-form-item>

      <el-form-item label="Invitation Code">
        <template slot="label">
          <I18Lang id="user10" defaultText="邀请码" />
        </template>
        <el-input v-model="formData.invite_code" :placeholder="$t('user100')"></el-input>
      </el-form-item>

      <div class="agree-check">
        <el-checkbox v-model="checked">{{$t('user101')}}</el-checkbox>
        <a href="">'{{$t('user102')}}'</a>{{$t('user103')}}<a href="">'{{$t('user104')}}'.</a>
      </div>

      <el-form-item>
        <el-button :loading="isSubmitLoading" type="primary" class="btn-view btn-red" @click="submitForm('formData')">
          <I18Lang id="user11" defaultText="注册" />
        </el-button>
      </el-form-item>
    </el-form>
    <el-dialog :show-close="false" :visible.sync="isDialogVerifiy" width="378px" :close-on-click-modal="false"
      :close-on-press-escape="false" class="verifiy-info-dialog">
      <slide-verify ref="slideblock" :imgs="verImgs" :l="42" :r="10" :w="340" :h="225" slider-text="Swipe to the right"
        @success="onSuccess" @fail="onFail" @refresh="onRefresh"></slide-verify>
    </el-dialog>
  </div>

</template>

<script>
import SendCode from '@/components/SendCode/SendCode.vue'
import cookie from '@utils/cookie'
import http from '@utils/http'
import i18n from '@utils/i18n'
export default {
  data () {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('public8'))) // '请输入姓名'
      } else {
        http
          .post('/api/user/checkIsExist', { username: value })
          .then((result) => {
            if (result.is_exist) {
              callback(new Error(i18n.t('public9'))) // 用户名已经存在，请填写其他用户名
              return false
            } else {
              callback()
            }
          })
      }
    }

    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('public47')))
      } else {
        callback()
      }
    }

    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('user25'))) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        if (this.formData.rePassword !== '') {
          this.$refs.formData.validateField('rePassword')
        }
        callback()
      }
    }
    const validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('public48')))
      } else if (value !== this.formData.password) {
        callback(new Error(i18n.t('public49')))
      } else {
        callback()
      }
    }

    const validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('public10'))) // 请输入邮箱
      } else {
        var emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i
        if (!emailRegex.test(value)) {
          callback(new Error(i18n.t('public11'))) // '邮箱格式有误，请重填'
          return false
        } else {
          callback()
        }
      }
    }

    return {
      isDialogVerifiy: false,
      verImgs: [
        require('../../../assets/img/ver/ver1.jpg'),
        require('../../../assets/img/ver/ver2.jpg'),
        require('../../../assets/img/ver/ver3.jpg'),
        require('../../../assets/img/ver/ver4.jpg'),
        require('../../../assets/img/ver/ver5.jpg'),
        require('../../../assets/img/ver/ver6.jpg'),
        require('../../../assets/img/ver/ver7.jpg')
      ],
      signType: 1,
      sendLoading: false,
      isSendCode: false,
      isSubmitLoading: false,
      checked: true,
      formData: {
        account_id: '',
        username: '',
        phone_number: '',
        code: '',
        password: '',
        rePassword: '',
        email: '',
        invite_code: ''
      },
      rules: {
        username: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        phone_number: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        code: [{ required: true, message: this.$t('public41'), trigger: 'blur' }],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        rePassword: [
          { required: true, validator: validateRePass, trigger: 'blur' }
        ],
        email: [
          { required: true, validator: validateEmail, trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.initReg()
  },
  computed: {
    emails () {
      // 如果inputEmail中没有任何东西，则不处理
      if (!this.formData.email) return []
      // 考虑到用户自己要输@符号，如果@符号首次出现的位置大于等于第零个位置时，则不处理
      if (this.formData.email.indexOf('@') > -1) return []
      return [
        this.formData.email + '@163.com',
        this.formData.email + '@126.com',
        this.formData.email + '@0355.net',
        this.formData.email + '@263.net',
        this.formData.email + '@3721.net',
        this.formData.email + '@qq.com',
        this.formData.email + '@yahoo.com',
        this.formData.email + '@gmail.com',
        this.formData.email + '@msn.com',
        this.formData.email + '@hotmail.com',
        this.formData.email + '@aol.com',
        this.formData.email + '@ask.com',
        this.formData.email + '@live.com',
        this.formData.email + '@yeah.net'
      ]
    }
  },
  methods: {
    initReg () {
      this.formData.invite_code = this.$route.query.invite_code || ''
      if (this.formData.invite_code) {
        cookie.set('kg-invite-code', this.formData.invite_code)
      }
    },
    onSuccess () {
      this.submitRegister()
    },
    onFail () { },
    onRefresh () { },
    usernameBlur () {
      this.$refs.formData.validateField(['username'], (result) => {
        if (!result) {
          this.$http.get('/api/user/registerAccountId').then((result) => {
            this.formData.account_id = result.account_id
          })
        }
      })
    },
    setEmailInput (mail) {
      this.formData.email = mail
    },
    tapSignType (type) {
      // 切换登录类型
      this.signType = type
    },
    async sendEmailCode () {
      // 发送验证码
      this.$refs.formData.validateField(['email'], (result) => {
        if (!result) {
          this.submitSendEmailAuthCode()
        }
      })
    },
    submitSendEmailAuthCode () {
      const params = {
        email: this.formData.email,
        event: 'register_validate'
      }
      this.sendLoading = true
      this.$http
        .post('/api/email/send', params, { direct: true })
        .then((result) => {
          if (result.code === 200) {
            this.isSendCode = true
            this.sendLoading = false
          } else {
            this.$message.error(result.msg)
          }
        })
        .catch(() => {
          this.sendLoading = false
        })
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDialogVerifiy = true
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submitRegister () {
      // 提交注册
      const params = this.formData
      const inviteCode = cookie.get('kg-invite-code')
      if (this.formData.invite_code) {
        params.invite_code = this.formData.invite_code
      } else if (inviteCode) {
        params.invite_code = inviteCode
      }
      this.$http
        .post('/api/user/register', this.formData)
        .then((result) => {
          cookie.set('kg-client-token', result.token || '')
          this.isSubmitLoading = false
          this.$store.dispatch('getUserInfo').then((result) => {
            this.isDialogVerifiy = false
            if (result.identity !== 0) {
              window.location.href = '/proxy'
            } else {
              window.location.href = '/user'
            }
          })
        })
        .catch(() => {
          this.$refs.slideblock.reset()
          this.isDialogVerifiy = false
          this.isSubmitLoading = false
        })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  components: {
    SendCode
  }
}
</script>

<style scoped lang="scss">
.verifiy-info-dialog {
  ::v-deep .el-dialog {
    border-radius: 10px;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 20px;
    }
  }
}

.right {
  flex: 0 0 50%;
  height: 100%;
  overflow-y: auto;
  padding-top: 48px;
  padding-bottom: 57px;

  .account-id {
    color: #00CCFF;
  }

}

.sign-form {
  width: 440px;
  margin: 0 auto;

  .reset-from {

    .form-item {
      margin-bottom: 35px;

      .form-item-label {
        font-size: 16px;
        font-weight: 400;
        color: #01B2F5;
      }

      .form-item-value {
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
      }
    }

    ::v-deep .el-form-item {
      .el-form-item__label {
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: #01B2F5;
      }

      input:-webkit-autofill {
        transition: background-color 5000s ease-out 0.5s;
        -webkit-text-fill-color: #fff;
      }

      .el-input__inner {
        width: 440px;
        height: 40px;
        border: 1px solid rgba(1, 178, 245, 0.5);
        line-height: 40px;
        background: transparent;
        color: #fff;
        border-radius: 0;
      }
    }

    .reset-input-code {
      ::v-deep {
        .el-input__inner {
          width: 100%;
          border-right: none;
          padding-right: 0;
        }

        .el-input-group__append {
          background: transparent;
          border: 1px solid rgba(1, 178, 245, 0.5);
          border-left: none;
          border-radius: 0;

          .btn {
            color: #01B2F5;
          }
        }
      }
    }

    .btn-submit {
      width: 110px;
      height: 55px;
      line-height: 55px;
      margin-left: -10px;
    }
  }

  .agree-check {
    margin-bottom: 47px;
    line-height: 24px;
    font-size: 16px;
    color: #fff;

    ::v-deep .el-checkbox__label {
      font-size: 16px;
      color: #fff;
    }

    a {
      font-size: 16px;
      color: #00CCFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;
    }
  }

  .btn-view {
    width: 100%;
    height: 48px;
    font-size: 16px;

    &.btn-red {
      background: #01B2F5;
      border-color: #01B2F5;
      border-radius: 0;
    }
  }

}
</style>
